/**
 * 智能对象滤镜链命令（M4-06 / ADR-0008）。
 *
 * 一个通用的「整链替换」结构命令覆盖增/删/启停/重排/改参——调用方算好
 * 新的 `filters` 数组，这里只管把它写进文档并保证可逆。逆操作存旧数组，
 * 成本与滤镜数成正比、与像素量无关（结构命令的标准写法）。
 */
import type { Command, Json } from '../command-bus';
import { findLayer } from '../../document/draft';
import type { LayerId, SmartFilter } from '../../document/types';

const STRUCTURAL_COST = 128;

export function createSetSmartFiltersCommand(id: LayerId, filters: readonly SmartFilter[]): Command {
  return {
    kind: 'smartObject.setFilters',
    label: '修改智能滤镜',
    cost: STRUCTURAL_COST * (filters.length + 1),
    // `SmartFilter` 没有索引签名，但字段全是纯数据；转换是精确类型，不是 any
    record: {
      kind: 'smartObject.setFilters',
      args: { id, filters } as unknown as Readonly<Record<string, Json>>,
    },
    apply(draft) {
      draft.updateLayer(id, (layer) => (layer.kind === 'smartObject' ? { ...layer, filters } : layer));
    },
    invert(document) {
      const layer = findLayer(document.root, id)?.layer;
      if (layer?.kind !== 'smartObject') return null;
      return createSetSmartFiltersCommand(id, layer.filters);
    },
  };
}
